module.exports = __webpack_public_path__ + "images/pattern-1.668f8f480f6e89fe0104b7e60043499a.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/pattern-1.jpg
// module id = 1022
// module chunks = 0